export default __webpack_public_path__ + "static/media/us1.14523a55.svg";